module.exports = __webpack_public_path__ + "static/media/bubble-active-1.6b79097f.svg";